import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getAgencyManagerUsers } from 'redux/selectors';
import { UserList, SlideContainer, Loader } from 'components';

export default function ManagerListContainer({ setInvite }) {
	const { push } = useHistory();
	const managerList = useSelector(getAgencyManagerUsers);

	const managerListMap =
		managerList === 'loading'
			? []
			: managerList?.map((val) => {
					const { firstname, lastname, email } = val;
					const hasName = firstname && lastname;
					const name = hasName ? `${val.firstname} ${val.lastname}` : email;
					return { ...val, name };
			  });

	const selectManager = (e, sw) => {
		e.stopPropagation();
		setInvite(false);
		push({ pathname: `/managers/manage/${sw.id}`, state: sw });
	};

	const onAddManager = () => {
		setInvite({ type: 'manager' });
	};

	if (managerList === 'loading') {
		return <Loader />;
	}

	return (
		<SlideContainer>
			<UserList
				list={managerListMap}
				label='Managers'
				pathParam='managerId'
				handleSelect={selectManager}
				addToggle={onAddManager}
				addLabel='Add a Manager'
			/>
		</SlideContainer>
	);
}
